import angular from 'angular';

angular.module('cxRelations').directive('cxRelSearchBox', [
  function() {
    return {
      restrict: 'E',
      //replace: true,
      template: require('./relSearchBox.html'),
      scope: true,
      controller: [
        '$scope',
        '$rootScope',
        'relBindSvc',
        'userData',
        '$transitions',
        '$state',
        function($scope, $rootScope, relBindSvc, userData, $transitions, $state) {
          $scope.relSearch = undefined;
          $scope.searchRelations = function(searchValue) {
            return resource.names({
              searchValue: searchValue,
              take: 15,
              includeInactive: false,
            }).$promise;
          };

          $scope.goToRelation = function() {
            relBindSvc.open($scope.relSearch.id).then(function() {
              $scope.relSearch = null;
            });
          };
          $scope.keyUp = function(event) {
            if (event.keyCode === 27) {
              $scope.form.search.$rollbackViewValue();
              $scope.relSearch = null;
            }
            if (event.keyCode === 13) {
              $scope.search();
            }
          };

          $scope.search = function() {
            $scope.form.search.$commitViewValue();
            if ($scope.relSearch && $scope.relSearch.id) {
              //$scope.goToRelation();
              return;
            }
            const relationName = $scope.relSearch ? $scope.relSearch.name || $scope.relSearch : '';
            $state.go('relations.overview', { relationName: relationName }).then(function() {
              $scope.relSearch = null;
            });
          };

          $scope.clearSearch = function() {
            $scope.relSearch = null;
            $state.go('relations.overview', { relationName: undefined });
          };

          $scope.toggleExpand = function() {
            $scope.expand = !$scope.expand;
          };
        },
      ],
    };
  },
]);
